import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { isPast } from 'date-fns'

import { rightSelector, rightWasLoadedSelector } from '../../../modules/selectors/rights'
import {
  combinedCampaignsErrorSelector,
  combinedCampaignsIsLoadingSelector
} from '../../../modules/selectors/combinedData'

const useUploadAdCreativeConstants = () => {
  const rightWasLoaded = useSelector(rightWasLoadedSelector)
  const combinedCampaignsIsLoading = useSelector(combinedCampaignsIsLoadingSelector)
  const combinedCampaignsError = useSelector(combinedCampaignsErrorSelector)
  const right = useSelector(rightSelector)

  // if get error state for combined campaigns, still show form loading - because we need to have campaigns for budget calculation
  const isFormLoading = !rightWasLoaded || combinedCampaignsIsLoading || !!combinedCampaignsError

  const isRightEndDateInThePast = isPast(new Date(right['end_date']))

  return useMemo(
    () => ({
      isFormLoading,
      isRightEndDateInThePast
    }),
    [isFormLoading, isRightEndDateInThePast]
  )
}

export default useUploadAdCreativeConstants
